















































































































import {Component, Vue, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import VueQrcode from 'vue-qrcode'
import ProductsToolbar from '@/components/lfs/Products/ProductsToolbar.vue'
import SelectedProduct from '@/components/lfs/Products/SelectedProduct.vue'
import TableComponent from "@/components/UI/TableComponent.vue";
import IClose from '@/components/icons/IClose.vue'
import Modal from '@/components/UI/Modal.vue';
import BtnDefault from '@/components/UI/BtnDefault.vue';
import IExport from '@/components/icons/IExport.vue'
import Search from "@/components/UI/Search.vue";
import {urlWithContour} from "@/helpers/currentContour";

const products = namespace('products')
const auth = namespace('auth')
const profile = namespace("profile")
const roistat = namespace('roistat')
const dialog = namespace('dialog')
const forms = namespace('forms')
const event = namespace('event')


@Component({
  components: {
    VueQrcode,
    ProductsToolbar,
    SelectedProduct,
    TableComponent,
    'i-close': IClose,
    Modal,
    BtnDefault,
    'i-export': IExport,
    Search,
  }
})
export default class Products extends Vue {
  @products.Action('loadProductsFromServer') protected loadProductsFromServer:any
  @products.Action('deleteProduct') protected deleteProductFromServer:any
  @products.Getter('products') protected products: any
  @products.Getter('loading') protected loading: any
  @auth.Getter('showId') protected showId: any
  @auth.State('exhibitorId') protected _exhibitor: any
  @profile.State("userCompany") protected userCompany: any
  @roistat.Action('sendEvent') protected sendEvent:any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
  @dialog.Mutation('SetFormSDialog') protected SetFormSDialog: any

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @forms.Mutation('setOptions') protected setOptions: any
  @event.Getter('shows') protected shows:any

  currentProduct:any = {}
  currentProductLink:string = ''
  currentProductTitle:string = ''
  qrDlgState:boolean = false
  isDeleteProductModal:boolean = false
  isSelectedProduct:boolean = false
  allProductsSvgDlgState:boolean = false
  allProductsSvgError: boolean = false
  allProductsSvgLink: string = ''
  search:string = ''
  disableSearch:boolean = false

  mounted() {
    this.loadProductsFromServer(this.shows[0].code)
  }

  @Watch('allProductsSvgLink')
  download() {
    this.downloadFile()
  }

  get items() {
    this.products.map((product:any) => product.subtitle = product.vendorCode)
    return this.products
  }

  get searchItems() {
    if (this.search.length) return this.items.filter((product: any) =>
      product.title.toLowerCase().includes(this.search.toLowerCase().trim()))
    return this.items
  }

  get headers() {
    return [
      { text: '', align: 'start', sortable: false, value: 'vendorCode', type: 'vendorCode', width: '70', action: 'openVendorCode', tooltip: this.$t('tooltip.qr_product')},
      { text: this.$t('products.table.name'), type:"titleWithSubtitle", value: 'title', sortable: false },
      { text: this.$t('products.table.thematic'), value: 'thematic', sortable: true, width: '300' },
      { text: this.$t('products.table.created'), type: "dateWithoutTime", value: 'createdAtTimestamp', sortable: true, width: '144' },
      { text: this.$t('products.table.updated'), type: "dateWithoutTime", value: 'updatedAtTimestamp', sortable: true, width: '144' },
      { text: '', value: 'edit', sortable: false, width: '48', type: 'icon', action: 'editProduct', itemTooltip: this.$t('tooltip.edit_product') },
      { text: '', value: 'delete', sortable: false, width: '48', type: 'icon', action: 'deleteProductModal', itemTooltip: this.$t('tooltip.delete_product')  },
    ]
  }

  get headersMinTable() {
    return [
      { text: '', align: 'start', sortable: false, value: 'vendorCode', type: 'vendorCode', width: '70', action: 'openVendorCode'},
      { text: this.$t('products.table.name'), type:"titleWithSubtitle", value: 'title', sortable: false },
      { text: '', value: 'edit', sortable: false, width: '48', type: 'icon', action: 'editProduct' },
      { text: '', value: 'delete', sortable: false, width: '48', type: 'icon', action: 'deleteProductModal' },
    ]
  }

  setFullTable() {
    this.isSelectedProduct = false
  }

  clickTable(item:any, action:any) {
    this.currentProduct = item
    this[action as keyof Products](item)
  }

  clearSearch() {
    this.search = ''
  }

  exportAll() {
    this.allProductsSvgLink = ''
    this.allProductsSvgError = false
    this.allProductsSvgDlgState = true

    Vue.axios({
        url: `/svgzip/${this._exhibitor}`,
        method: 'GET'
    })
    .then((resp: any) => {

        if (resp.data.code === '01') {
        this.allProductsSvgLink = resp.data.link
        } else {
        this.allProductsSvgError = true
        }
    })
    .catch((err: any) => {
        this.allProductsSvgError = true
    })
  }

  downloadFile() {
    document.location.href = this.allProductsSvgLink
    this.allProductsSvgDlgState = false
    let params = [
    {
        "name": "“Продукция”: Действие “Скачать файлы для печати QR кода” - “Скачать файл”",
        "data": {
        "company": this.userCompany.title
        }
    }
    ]
  }

  openVendorCode (item:any): void {
    this.currentProductLink = `${urlWithContour()}/p/${ item.id }`
    this.currentProductTitle = item.title
    this.qrDlgState = true
    let params = [
      {
        "name": "“Продукция”: Действие “Показать QR”",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }

  clickRow(item:any) {
    this.currentProduct = item
    this.isSelectedProduct = true
  }

  deleteProductModal(item:any) {
    this.currentProduct = item
    this.isDeleteProductModal = true
  }

  deleteProduct() {
    this.deleteProductFromServer(this.currentProduct.id)
    this.isDeleteProductModal = false
    this.isSelectedProduct = false
  }

  editProduct(item:any) {
    this.setOptions(item)
    this.SetTitleDialog(this.$t('products.edit_title'))
    this.SetFormSDialog('EditProductForm')
    this.SetFullDialogShow(true)
  }

  addProduct() {
    this.setOptions()
    this.SetTitleDialog(this.$t('products.add.title'))
    this.SetFormSDialog('AddProductForm')
    this.SetFullDialogShow(true)
  }

}
